import { Row } from 'antd';
import moment from 'moment';
import { UserDto, CreateOfferWatchDto } from 'src/dtos';
import { MFormTextField, MTypography, SubmissionResult } from 'src/lib';
import { OfferDetails } from 'src/models';
import { Color, Image } from 'src/styles';

import { NewOfferWatchDisclaimer } from './NewOfferWatchDisclaimer';
import * as Styles from './NewOfferWatchModal.styles';

export const NewOfferWatchSucceeded = ({
  offer,
  offerWatch,
  user,
}: {
  offer: OfferDetails;
  offerWatch: CreateOfferWatchDto;
  user: UserDto;
}) => {
  const data = [
    {
      label: 'Investor Name',
      value: `${user.firstName} ${user.lastName}`,
    },
    { label: 'Date', value: moment(new Date().toISOString()).format('MM/DD/YYYY') },
    { label: 'First Name', value: user.firstName },
    { label: 'Last Name', value: user.lastName },
    { label: 'Email', value: user.email },
    { label: 'Phone Number', value: user.phoneNumber },
    { label: 'State', value: user.address.state },
    { label: 'Investment Range', value: offerWatch?.investmentRange },
  ];

  return (
    <div>
      <SubmissionResult type='success' />
      <Row>
        <MTypography variant='body1' align='center' color={Color.Gray7} className={Styles.subtitle}>
          You will receive updates and notifications when the Offer becomes for actual investment
        </MTypography>
      </Row>
      <Row className={Styles.title}>
        <img className={Styles.offerLogo} src={offer?.logoUrl || Image.DefaultOffering} alt={`${offer.name}_logo`} />
        <MTypography variant='subtitle1' weight='bold' color={Color.Gray10} inline>
          {offer.name}
        </MTypography>
      </Row>
      <Row>
        {data.map(item => (
          <MFormTextField key={item.label} label={item.label} value={item.value} />
        ))}
      </Row>
      <NewOfferWatchDisclaimer />
    </div>
  );
};
